import script from "./retreatForm.vue?vue&type=script&setup=true&lang=js"
export * from "./retreatForm.vue?vue&type=script&setup=true&lang=js"

import "./retreatForm.vue?vue&type=style&index=0&id=e5e5312a&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5e5312a"]])

export default __exports__